
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.83 14.774c.11.164.17.356.17.554v7l-4.71-4.71 3-3a1 1 0 011.09-.21 1 1 0 01.45.366zm-7.32 4.554l-3.22-3.21 1.42-1.42 18 18-1.42 1.42-7.29-7.3v6.51a1 1 0 01-.62.92.842.842 0 01-.38.08 1 1 0 01-.71-.29l-4.7-4.71H15a1 1 0 01-1-1v-8a1 1 0 011-1h2.51zm10.39 5.85l1.58 1.58a6 6 0 00-1.36-6.78l-1.34 1.48a3.92 3.92 0 011.12 3.72zm4.54 4.51L31 28.248a8 8 0 00-1.55-9.76l1.34-1.48a10 10 0 013.21 7.32 9.84 9.84 0 01-1.56 5.36z","fill":"#fff"}})])
          )
        }
      }
    